import * as yup from "yup";

const courtValidationSchema = yup.object().shape({
  locationId: yup
    .number()
    .integer("Location ID must be an integer")
    .min(0, "Location ID must be a non-negative number")
    .required("Location ID is required"),

  courtName: yup
    .string()
    .required("Court name is required")
    .trim()
    .max(100, "Court name cannot exceed 100 characters"),

  courtDescription: yup
    .string()
    .required("Court description is required")
    .trim()
    .max(500, "Court description cannot exceed 500 characters"),

  courtSportType: yup
    .string()
    .required("Court sport type is required")
    .trim()
    .max(50, "Court sport type cannot exceed 50 characters"),

  // courtSlotDuration: yup
  //   .number()
  //   .integer("Court slot duration must be an integer")
  //   .positive("Court slot duration must be a positive number")
  //   .required("Court slot duration is required"),

  // courtStatusId: yup
  //   .number()
  //   .integer("Court status ID must be an integer")
  //   .min(0, "Court status ID must be a non-negative number")
  //   .required("Court status ID is required"),

  courtMainImage: yup.object().required(),
  // .url("Court main image must be a valid URL"),

  courtThumbnailImage: yup
    .string()
    .required("Court thumbnail image is required"),
  // .url("Court thumbnail image must be a valid URL"),

  courtPreviewImages: yup
    .array()
    .of(yup.object())
    .max(5, "Court preview images cannot exceed 5 images")
    .required("Court preview images are required"),
  courtTimings: yup
    .array()
    .of(
      yup
        .object()
        .typeError("Each court timing must be defined")
        .required("Court timing is required")
    )
    .required("Court timing is required"),

  // courtTimings: yup.array().of(
  //   yup.object().shape({
  //     day: yup.mixed().required("Day is required"),
  //     startTime: yup.mixed().required("Start time is required"),
  //     endTime: yup.mixed()
  //       .required("End time is required")
  //       .test(
  //         "is-after-start",
  //         "End time must be after start time",
  //         function (endTime, context) {
  //           const { startTime } = context.parent;
  //           if (!startTime || !endTime) return true; // Skip validation if either is not set

  //           // Compare the time values
  //           return new Date(endTime) > new Date(startTime);
  //         }
  //       ),
  //     amount: yup.number()
  //       .required("Amount is required")
  //       .typeError("Amount must be a number")
  //       .positive("Amount must be positive")
  //   })
  // ).min(1, "At least one timing slot is required"),
});

export default courtValidationSchema;
